var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.filesGroupLocal)?_c('FilesField',{attrs:{"category":_vm.filesGroupLocal,"content-type":_vm.contentType,"size-img":_vm.sizeImg}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }